export default __webpack_public_path__ + "static/media/Img_List_Empty.4dace93e.png";